module.exports = __webpack_public_path__ + "static/media/balmain_2.20a23daf.jpg";